// ── Couleurs par source ───────────────────────────────────────────────────────

export const SOURCE_COLORS = {
    etab:                   '#1976d2',
    bdnb:                   '#388e3c',
    batimentGroupe:         '#f57c00',
    BdnbProp:               '#7b1fa2',
    BdnbBatimentGroupeRnc:  '#c62828',
    Dpes:                   '#00838f',
    BatimentGroupeAdresses: '#5d4037',
    Parcelles:              '#558b2f',
};

// ── Accesseurs de données par source ─────────────────────────────────────────

export const SOURCE_DATA_MAP = {
    etab:                   e => e.etab,
    bdnb:                   e => e.batiments,
    batimentGroupe:         e => e.batimentGroupe,
    BdnbProp:               e => e.proprietaires,
    BdnbBatimentGroupeRnc:  e => e.batimentGroupeRnc,
    BatimentGroupeAdresses: e => e.batimentGroupeAdresses,
    Parcelles:              e => e.parcelles,
    Dpes:                   e => e.dpes,
};

// ── Configuration des sources (ordre d'affichage) ─────────────────────────────

export const SOURCES_CONFIG = [
    {key: 'etab',                   label: 'Établissements',     color: SOURCE_COLORS.etab},
    {key: 'Dpes',                   label: 'DPEs',               color: SOURCE_COLORS.Dpes},
    {key: 'BdnbProp',               label: 'BDNB Propriétés',    color: SOURCE_COLORS.BdnbProp},
    {key: 'bdnb',                   label: 'BDNB Bâtiments',     color: SOURCE_COLORS.bdnb},
    {key: 'BdnbBatimentGroupeRnc',  label: 'BDNB Groupe RNC',    color: SOURCE_COLORS.BdnbBatimentGroupeRnc},
    {key: 'batimentGroupe',         label: 'BDNB Groupe',        color: SOURCE_COLORS.batimentGroupe},
    {key: 'BatimentGroupeAdresses', label: 'BDNB Adr. Groupes', color: SOURCE_COLORS.BatimentGroupeAdresses},
    {key: 'Parcelles',              label: 'Parcelles',          color: SOURCE_COLORS.Parcelles},
];

